import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Resources } from './pages/Resources';
import { Contact } from './pages/Contact';
import { useLocalBusinessSchema } from './utils/seo';
function ScrollManager() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.replace('#', ''));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        return;
      }
    }
    window.scrollTo({
      top: 0,
      left: 0
    });
  }, [pathname, hash]);
  return null;
}
export function App() {
  useLocalBusinessSchema();
  return <BrowserRouter data-id="element-0" data-mp="23vuokdaowwv5">
      <ScrollManager data-id="element-1" data-mp="23u9ueosaffxt" />
      <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-2" data-mp="23utadzydnu97">
        <a href="#hoofdinhoud" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:bg-ink focus:px-4 focus:py-2 focus:text-white" data-id="element-3" data-mp="3ikqz80j1f669">
          Direct naar de inhoud
        </a>
        <Header data-id="element-4" data-mp="3recedkz46pg7" />
        <main id="hoofdinhoud" className="flex-1" data-id="element-5" data-mp="5yjetptzbev">
          <Routes data-id="element-6" data-mp="4n6a3ahwrb3">
            <Route path="/" element={<Home data-id="element-8" data-mp="2zl3a7gleoy37" />} data-id="element-7" data-mp="56l3b4umzkw" />
            <Route path="/over-ons" element={<About data-id="element-10" data-mp="2zmem63p09c5e" />} data-id="element-9" data-mp="2zllcouynw8jk" />
            <Route path="/diensten" element={<Services data-id="element-12" data-mp="33mf623uvifju" />} data-id="element-11" data-mp="2zn6bwxvx8fnr" />
            <Route path="/resources" element={<Resources data-id="element-14" data-mp="33orhrza1ftog" />} data-id="element-13" data-mp="33nq55qddiz4m" />
            <Route path="/contact" element={<Contact data-id="element-16" data-mp="38kqce4lym7xb" />} data-id="element-15" data-mp="38m1fs3bhtdnw" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-18" data-mp="38o4fjf2g6l5t" />} data-id="element-17" data-mp="38kgkucl9nspi" />
          </Routes>
        </main>
        <Footer data-id="element-19" data-mp="3dm5xtxs1ugg8" />
      </div>
    </BrowserRouter>;
}